import React, { useEffect, useState, useContext, useMemo } from 'react';
import {
    Widget,
    Table,
    Col,
    Row,
    Button,
    FormInput,
    Form,
    FormResetButton,
} from '@digital/ui';
import moment from 'moment';
import { dateTimeFormat } from '@app/helpers/dateTimeFormats';
import { currencyFormat } from '@app/helpers/numbers';
import { Collapse, Tooltip, Icon } from 'antd';

import {
    ContabilidadeGeralModel,
    viewArquivoAutorizacao,
    downloadArquivoAutorizacao,
    downloadArquivoCartaCorrecao,
    viewArquivoCartaCorrecao,
    downloadArquivoComprovanteCancelamento,
    viewArquivoComprovanteCancelamento
} from '@app/api/ContabilidadeGeral';
import ModalJustificativas from '@app/views/ContabilidadeGeral/Justificativas/modalJustificativas';
import ModalRecusar from '@app/views/ContabilidadeGeral/PendentesBaixadosRecusados/Acoes/modalRecusar';
import ButtonConfirmarIntegracao from './Acoes/buttonConfirmarIntegracao';
import { hasPermission } from '@app/helpers/permissions';
import { compareNumber, compareText } from '@app/helpers/comparators';
import ModalExcluir from './Acoes/modalExcluir';

export interface propsPendentesBaixadosRecusados {
    pendentesBaixadosRecusados: ContabilidadeGeralModel;
    updatePage: any;
}

const PendentesBaixadosRecusados = (props: propsPendentesBaixadosRecusados) => {

    const { pendentesBaixadosRecusados, updatePage } = props;
    const { Panel } = Collapse;

    const column = [
        {
            title: 'Número do Fornecedor',
            dataIndex: 'numeroFornecedor',
            width: '7%',
            sorter: (a, b) => compareNumberString(a.numeroFornecedor, b.numeroFornecedor),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Número do Fornecedor"
                            name="numeroFornecedor"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.numeroFornecedor !== undefined &&
                record.numeroFornecedor
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'Número do CT',
            dataIndex: 'numeroContrato',
            sorter: (a, b) => compareNumberString(a.numeroContrato, b.numeroContrato),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Número do Contrato"
                            name="numeroContrato"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.numeroContrato !== undefined &&
                record.numeroContrato
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'CNPJ',
            dataIndex: 'cnpjFornecedor',
            sorter: (a, b) => compareNumberString(a.cnpjFornecedor, b.cnpjFornecedor),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar CNPJ"
                            name="cnpjFornecedor"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.cnpjFornecedor !== undefined &&
                record.cnpjFornecedor
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'Razão Social',
            dataIndex: 'razaoSocialFornecedor',
            sorter: (a, b) => compareText(a.razaoSocialFornecedor, b.razaoSocialFornecedor),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Razão Social"
                            name="razaoSocialFornecedor"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.razaoSocialFornecedor !== undefined &&
                record.razaoSocialFornecedor
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'Número do Documento TOTVS',
            dataIndex: 'numeroTotvs',
            sorter: (a, b) => compareNumberString(a.numeroTotvs, b.numeroTotvs),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Número do Documento"
                            name="numeroTotvs"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.numeroTotvs !== undefined &&
                record.numeroTotvs
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'Tipo',
            dataIndex: 'tipoArquivoAutorizacao',
            width: '5%',
        },
        {
            title: 'Valor',
            dataIndex: 'valorArquivoAutorizacao',
            render: (text, record) => currencyFormat(record.valorArquivoAutorizacao),
            width: '10%',
        },
        {
            title: 'Condição de Pagamento',
            dataIndex: 'condicaoPagamento',
        },
        {
            title: 'Crédito PIS/COFINS',
            dataIndex: 'creditoPisCofins',
            render: (text, record) => record.creditoPisCofins ? 'Sim' : 'Não',
            width: '5%'
        },
        {
            title: 'Data de Upload pelo Fornecedor',
            dataIndex: 'dataUploadArquivo',
            render: (text, record) => moment(record.dataUploadArquivo).format(dateTimeFormat)
        },
        {
            title: 'Status Contabilidade Geral',
            dataIndex: 'statusContabilidadeGeral'
        },
        {
            title: 'Status Faturamento',
            dataIndex: 'statusFaturamento',
        },
    ];

    let pendentes = [{
        title: 'Ações',
        render: (text, record) => (
            <>
                {
                    (record.nomeArquivo.slice(-3).toLowerCase() === 'pdf' ?
                        <Tooltip title="Visualizar Arquivo">
                            <Button
                                onClick={async () => {
                                    await viewArquivoAutorizacao(record.idArquivoAutorizacao);
                                    updatePage();
                                }}

                                icon="files-view_file"
                                name="btnVisualizarArquivo"
                            />
                        </Tooltip>
                        :
                        <Tooltip title="Baixar Arquivo">
                            <Button
                                onClick={async () => {
                                    await downloadArquivoAutorizacao(record.idArquivoAutorizacao, record.nomeArquivo);
                                    updatePage();
                                }}
                                icon="ui-download"
                                name="btnBaixarArquivo"
                            />
                        </Tooltip>
                    )
                }
                {
                    record.arquivoCartaCorrecaoId != null &&
                    (
                        record.nomeArquivoCartaCorrecao.slice(-3).toLowerCase() === 'pdf' ?
                            <Tooltip title="Visualizar Carta Correção">
                                <Button
                                    onClick={async () => {
                                        await viewArquivoCartaCorrecao({
                                            arquivoCartaCorrecaoId: record.arquivoCartaCorrecaoId,
                                            arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                            filename: record.nomeArquivoCartaCorrecao
                                        });
                                        updatePage();
                                    }}
                                    icon="folders-burn_folder"
                                    name="btnBaixarCartaCorrecao"
                                />
                            </Tooltip>
                            :
                            <Tooltip title={"Baixar Carta Correção"}>
                                <Button
                                    onClick={async () => {
                                        await downloadArquivoCartaCorrecao({
                                            arquivoCartaCorrecaoId: record.arquivoCartaCorrecaoId,
                                            arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                            filename: record.nomeArquivoCartaCorrecao
                                        });
                                        updatePage();
                                    }}
                                    icon="folders-downloads_folder"
                                    name="btnBaixarCartaCorrecao"
                                />
                            </Tooltip>
                    )
                }
                {
                    record.arquivoComprovanteCancelamentoId != null &&
                    (
                        record.nomeArquivoComprovanteCancelamento.slice(-3).toLowerCase() === 'pdf' ?
                            <Tooltip title="Visualizar Comprovante Cancelamento">
                                <Button
                                    onClick={async () => {
                                        await viewArquivoComprovanteCancelamento({
                                            arquivoComprovanteCancelamentoId: record.arquivoComprovanteCancelamentoId,
                                            arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                            filename: record.nomeArquivoComprovanteCancelamento
                                        });
                                    }}
                                    icon="folders-delete_folder"
                                    name="btnBaixarComprovanteCancelamento"
                                />
                            </Tooltip>
                            :
                            <Tooltip title={"Baixar Comprovante Cancelamento"}>
                                <Button
                                    onClick={async () => {
                                        await downloadArquivoComprovanteCancelamento({
                                            arquivoComprovanteCancelamentoId: record.arquivoComprovanteCancelamentoId,
                                            arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                            filename: record.nomeArquivoComprovanteCancelamento
                                        });
                                    }}
                                    icon="folders-delete_folder"
                                    name="btnBaixarComprovanteCancelamento"
                                />
                            </Tooltip>
                    )
                }
                {
                    record.codigoStatusContabilidadeGeral == 2 &&
                    hasPermission(['CONTABILIDADE_GERAL_EDITAR']) &&
                    (
                        <ModalRecusar arquivoAutorizacaoId={record.idArquivoAutorizacao} updatePage={updatePage} />
                    )
                }
                {
                    record.codigoStatusContabilidadeGeral == 2 &&
                    hasPermission(['CONTABILIDADE_GERAL_EDITAR']) &&
                    (
                        <ButtonConfirmarIntegracao arquivoAutorizacaoId={record.idArquivoAutorizacao} updatePage={updatePage} />
                    )
                }
                {
                    record.codigoStatusContabilidadeGeral == 3 && (
                        <ModalJustificativas arquivoAutorizacaoId={record.idArquivoAutorizacao} contemComentario={(record.comentarios > 0)} />
                    )
                }
            </>
        )
    },];

    let baixados = [
        {
            title: 'Responsável Contábil',
            dataIndex: 'responsavelVisaoBaixado',
        },
        {
            title: 'Ações',
            render: (text, record) => (
                <>
                    {
                        (record.nomeArquivo.slice(-3).toLowerCase() === 'pdf' ?
                            <Tooltip title="Visualizar Arquivo">
                                <Button
                                    onClick={async () => {
                                        await viewArquivoAutorizacao(record.idArquivoAutorizacao);
                                        updatePage();
                                    }}

                                    icon="files-view_file"
                                    name="btnVisualizarArquivo"
                                />
                            </Tooltip>
                            :
                            <Tooltip title="Baixar Arquivo">
                                <Button
                                    onClick={async () => {
                                        await downloadArquivoAutorizacao(record.idArquivoAutorizacao, record.nomeArquivo);
                                        updatePage();
                                    }}
                                    icon="ui-download"
                                    name="btnBaixarArquivo"
                                />
                            </Tooltip>
                        )
                    }
                    {
                        record.arquivoCartaCorrecaoId != null &&
                        (
                            record.nomeArquivoCartaCorrecao.slice(-3).toLowerCase() === 'pdf' ?
                                <Tooltip title="Visualizar Carta Correção">
                                    <Button
                                        onClick={async () => {
                                            await viewArquivoCartaCorrecao({
                                                arquivoCartaCorrecaoId: record.arquivoCartaCorrecaoId,
                                                arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                                filename: record.nomeArquivoCartaCorrecao
                                            });
                                            updatePage();
                                        }}
                                        icon="folders-burn_folder"
                                        name="btnBaixarCartaCorrecao"
                                    />
                                </Tooltip>
                                :
                                <Tooltip title={"Baixar Carta Correção"}>
                                    <Button
                                        onClick={async () => {
                                            await downloadArquivoCartaCorrecao({
                                                arquivoCartaCorrecaoId: record.arquivoCartaCorrecaoId,
                                                arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                                filename: record.nomeArquivoCartaCorrecao
                                            });
                                            updatePage();
                                        }}
                                        icon="folders-downloads_folder"
                                        name="btnBaixarCartaCorrecao"
                                    />
                                </Tooltip>
                        )
                    }
                    {
                        record.arquivoComprovanteCancelamentoId != null &&
                        (
                            record.nomeArquivoComprovanteCancelamento.slice(-3).toLowerCase() === 'pdf' ?
                                <Tooltip title="Visualizar Comprovante Cancelamento">
                                    <Button
                                        onClick={async () => {
                                            await viewArquivoComprovanteCancelamento({
                                                arquivoComprovanteCancelamentoId: record.arquivoComprovanteCancelamentoId,
                                                arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                                filename: record.nomeArquivoComprovanteCancelamento
                                            });
                                        }}
                                        icon="folders-delete_folder"
                                        name="btnBaixarComprovanteCancelamento"
                                    />
                                </Tooltip>
                                :
                                <Tooltip title={"Baixar Comprovante Cancelamento"}>
                                    <Button
                                        onClick={async () => {
                                            await downloadArquivoComprovanteCancelamento({
                                                arquivoComprovanteCancelamentoId: record.arquivoComprovanteCancelamentoId,
                                                arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                                filename: record.nomeArquivoComprovanteCancelamento
                                            });
                                        }}
                                        icon="folders-delete_folder"
                                        name="btnBaixarComprovanteCancelamento"
                                    />
                                </Tooltip>
                        )
                    }
                    {
                        record.codigoStatusContabilidadeGeral == 2 &&
                        hasPermission(['CONTABILIDADE_GERAL_EDITAR']) &&
                        (
                            <ModalRecusar arquivoAutorizacaoId={record.idArquivoAutorizacao} updatePage={updatePage} />
                        )
                    }
                    {
                        record.codigoStatusContabilidadeGeral == 2 &&
                        hasPermission(['CONTABILIDADE_GERAL_EDITAR']) &&
                        (
                            <ButtonConfirmarIntegracao arquivoAutorizacaoId={record.idArquivoAutorizacao} updatePage={updatePage} />
                        )
                    }
                    {
                        record.codigoStatusContabilidadeGeral == 3 && (
                            <ModalJustificativas arquivoAutorizacaoId={record.idArquivoAutorizacao} contemComentario={(record.comentarios > 0)} />
                        )
                    }
                </>
            )
        },];

    let recusados = [
        {
            title: 'Responsável Contábil',
            dataIndex: 'responsavelVisaoRecusado',
        },
        {
            title: 'Ações',
            render: (text, record) => (
                <>
                    {
                        hasPermission(['CONTABILIDADE_GERAL_EDITAR']) ?
                            <ModalExcluir arquivoAutorizacaoId={record.idArquivoAutorizacao} updatePage={updatePage} /> :
                            <></>
                    }
                    {
                        (record.nomeArquivo.slice(-3).toLowerCase() === 'pdf' ?
                            <Tooltip title="Visualizar Arquivo">
                                <Button
                                    onClick={async () => {
                                        await viewArquivoAutorizacao(record.idArquivoAutorizacao);
                                        updatePage();
                                    }}

                                    icon="files-view_file"
                                    name="btnVisualizarArquivo"
                                />
                            </Tooltip>
                            :
                            <Tooltip title="Baixar Arquivo">
                                <Button
                                    onClick={async () => {
                                        await downloadArquivoAutorizacao(record.idArquivoAutorizacao, record.nomeArquivo);
                                        updatePage();
                                    }}
                                    icon="ui-download"
                                    name="btnBaixarArquivo"
                                />
                            </Tooltip>
                        )
                    }
                    {
                        record.arquivoCartaCorrecaoId != null &&
                        (
                            record.nomeArquivoCartaCorrecao.slice(-3).toLowerCase() === 'pdf' ?
                                <Tooltip title="Visualizar Carta Correção">
                                    <Button
                                        onClick={async () => {
                                            await viewArquivoCartaCorrecao({
                                                arquivoCartaCorrecaoId: record.arquivoCartaCorrecaoId,
                                                arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                                filename: record.nomeArquivoCartaCorrecao
                                            });
                                            updatePage();
                                        }}
                                        icon="folders-burn_folder"
                                        name="btnBaixarCartaCorrecao"
                                    />
                                </Tooltip>
                                :
                                <Tooltip title={"Baixar Carta Correção"}>
                                    <Button
                                        onClick={async () => {
                                            await downloadArquivoCartaCorrecao({
                                                arquivoCartaCorrecaoId: record.arquivoCartaCorrecaoId,
                                                arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                                filename: record.nomeArquivoCartaCorrecao
                                            });
                                            updatePage();
                                        }}
                                        icon="folders-downloads_folder"
                                        name="btnBaixarCartaCorrecao"
                                    />
                                </Tooltip>
                        )
                    }
                    {
                        record.arquivoComprovanteCancelamentoId != null &&
                        (
                            record.nomeArquivoComprovanteCancelamento.slice(-3).toLowerCase() === 'pdf' ?
                                <Tooltip title="Visualizar Comprovante Cancelamento">
                                    <Button
                                        onClick={async () => {
                                            await viewArquivoComprovanteCancelamento({
                                                arquivoComprovanteCancelamentoId: record.arquivoComprovanteCancelamentoId,
                                                arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                                filename: record.nomeArquivoComprovanteCancelamento
                                            });
                                        }}
                                        icon="folders-delete_folder"
                                        name="btnBaixarComprovanteCancelamento"
                                    />
                                </Tooltip>
                                :
                                <Tooltip title={"Baixar Comprovante Cancelamento"}>
                                    <Button
                                        onClick={async () => {
                                            await downloadArquivoComprovanteCancelamento({
                                                arquivoComprovanteCancelamentoId: record.arquivoComprovanteCancelamentoId,
                                                arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                                filename: record.nomeArquivoComprovanteCancelamento
                                            });
                                        }}
                                        icon="folders-delete_folder"
                                        name="btnBaixarComprovanteCancelamento"
                                    />
                                </Tooltip>
                        )
                    }
                    {
                        record.codigoStatusContabilidadeGeral == 2 &&
                        hasPermission(['CONTABILIDADE_GERAL_EDITAR']) &&
                        (
                            <ModalRecusar arquivoAutorizacaoId={record.idArquivoAutorizacao} updatePage={updatePage} />
                        )
                    }
                    {
                        record.codigoStatusContabilidadeGeral == 2 &&
                        hasPermission(['CONTABILIDADE_GERAL_EDITAR']) &&
                        (
                            <ButtonConfirmarIntegracao arquivoAutorizacaoId={record.idArquivoAutorizacao} updatePage={updatePage} />
                        )
                    }
                    {
                        record.codigoStatusContabilidadeGeral == 3 && (
                            <ModalJustificativas arquivoAutorizacaoId={record.idArquivoAutorizacao} contemComentario={(record.comentarios > 0)} />
                        )
                    }
                </>
            )
        },];

    let columnPendentes = [...column, ...pendentes];
    let columnBaixados = [...column, ...baixados];
    let columnRecusados = [...column, ...recusados];

    return (
        <>
            <Collapse bordered={false} defaultActiveKey={['pendentes']} expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel
                    key='pendentes'
                    header={'Pendentes'}
                >
                    <Widget>
                        <Row>
                            <Col>
                                <Table columns={columnPendentes} rowKey='idArquivoAutorizacao' dataSource={pendentesBaixadosRecusados.contabilidadePendentes || []} />
                            </Col>
                        </Row>
                    </Widget>
                </Panel>
            </Collapse>

            <Collapse bordered={false} defaultActiveKey={['baixados']} expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel
                    key='baixados'
                    header={'Baixados'}
                >
                    <Widget>
                        <Row>
                            <Col>
                                <Table columns={columnBaixados} rowKey='idArquivoAutorizacao' dataSource={pendentesBaixadosRecusados.contabilidadeBaixados || []} />
                            </Col>
                        </Row>
                    </Widget>
                </Panel>
            </Collapse>

            <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel
                    key='recusados'
                    header={'Recusados'}
                >
                    <Widget>
                        <Row>
                            <Col>
                                <Table columns={columnRecusados} rowKey='idArquivoAutorizacao' dataSource={pendentesBaixadosRecusados.contabilidadeRecusados || []} />
                            </Col>
                        </Row>
                    </Widget>
                </Panel>
            </Collapse>
        </>
    );
};

export default PendentesBaixadosRecusados;